import i18next from 'i18next'

import en from './resources/en'
import de from './resources/de'
import fr from './resources/fr'
import it from './resources/it'

export const defaultLanguage = 'en'
export const allowedLanguages = ['en', 'de', 'fr', 'it']

i18next
    .init({
        debug: (process.env.NODE_ENV === 'development'),
        lng: defaultLanguage,
        fallbackLng: defaultLanguage,
        whitelist: allowedLanguages,
        defaultNS: 'general',
        resources: {
            en,
            de,
            fr,
            it
        }
    })

export default i18next
